module.exports = __webpack_public_path__ + "media/images/path@2x-2d1101da3bf4246a40e7b95d9e50c18c.png";